import * as React from "react";
import { cn } from "../../lib/utils";

export interface ShadcnHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
    as?: keyof JSX.IntrinsicElements;
}

export const ShadcnHeading: React.FC<ShadcnHeadingProps> = ({
    as = "div",
    className,
    children,
    ...props
}) => {
    const Tag = as as React.ElementType;
    return (
        <Tag
            className={cn(
                "font-semibold text-foreground",
                className
            )}
            style={props.style || undefined}
            {...props}
        >
            {children}
        </Tag>
    );
};
